import React from "react";
import "./landing.css";
import { brandColors } from "../../design-system/tokens";

const WaveBackground = ({ children, variant = "blue", className = "" }) => {
  const isInverse = variant === "inverse";
  const containerClass = isInverse
    ? `landing-wave-inverse ${brandColors.waveSurfaceInverseBg}`
    : `landing-wave-blue ${brandColors.waveGradientAnimated}`;

  const wave1Fill = isInverse ? brandColors.waveInverseFill1 : brandColors.waveFill1;
  const wave2Fill = isInverse ? brandColors.waveInverseFill2 : brandColors.waveFill2;

  return (
    <div className={`${containerClass} ${className}`.trim()}>
      <div className="landing-waves" aria-hidden="true">
        {/* Wave 1 with previous + next duplicates for perfect wrap */}
        <svg
          className={`landing-wave landing-wave-1 ${wave1Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V46.29c47.79,22,103.59,29.05,158,17,70-15,136-62,206-57,73,5,142,64,215,73,83,10,168-42,251-45,74-3,148,34,221,51,40,9,82,12,149,7V0Z"></path>
        </svg>
        <svg
          className={`landing-wave landing-wave-1 landing-wave-dup ${wave1Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V46.29c47.79,22,103.59,29.05,158,17,70-15,136-62,206-57,73,5,142,64,215,73,83,10,168-42,251-45,74-3,148,34,221,51,40,9,82,12,149,7V0Z"></path>
        </svg>
        <svg
          className={`landing-wave landing-wave-1 landing-wave-dup-prev ${wave1Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V46.29c47.79,22,103.59,29.05,158,17,70-15,136-62,206-57,73,5,142,64,215,73,83,10,168-42,251-45,74-3,148,34,221,51,40,9,82,12,149,7V0Z"></path>
        </svg>

        {/* Wave 2 with previous + next duplicates for perfect wrap */}
        <svg
          className={`landing-wave landing-wave-2 ${wave2Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V15.81C65,32.18,129,48.55,199,44c88-6,175-54,263-50,60,3,117,35,177,43,82,12,168-24,250-32,52-5,103,2,153,13,35,8,69,18,158,34V0Z"></path>
        </svg>
        <svg
          className={`landing-wave landing-wave-2 landing-wave-dup ${wave2Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V15.81C65,32.18,129,48.55,199,44c88-6,175-54,263-50,60,3,117,35,177,43,82,12,168-24,250-32,52-5,103,2,153,13,35,8,69,18,158,34V0Z"></path>
        </svg>
        <svg
          className={`landing-wave landing-wave-2 landing-wave-dup-prev ${wave2Fill}`}
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path d="M0,0V15.81C65,32.18,129,48.55,199,44c88-6,175-54,263-50,60,3,117,35,177,43,82,12,168-24,250-32,52-5,103,2,153,13,35,8,69,18,158,34V0Z"></path>
        </svg>
      </div>
      {children}
    </div>
  );
};

export default WaveBackground;

